import * as React from "react";
import {authorize} from "@athena-portal/components";
import {RouteComponentProps} from "react-router";
import FalconHeader from "../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../utils/PluginTemplates";
import FalconFooter from "../../../components/navigation/FalconFooter";
import {ButtonLink} from "../../../components/navigation/ButtonLink";
import {FalconNavigatorHeader, ICustomerPortalService, Policy, productHelper, Types} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";

interface IProps extends RouteComponentProps<{}> {
}

interface IState {
    link: string,
    motorChecked: boolean,
    rentersChecked: boolean,
    annualMotorChecked: boolean,
    policies?: Policy[];
}

@authorize
export class PickClaimKindPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            link: "",
            motorChecked: false,
            rentersChecked: false,
            annualMotorChecked: false
        };
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Your claims");

        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            this.setState({
                policies
            });
        });
    }

    public render() {
        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="plugin claims">
                    <FalconNavigatorHeader back="/dashboard" title="Make a claim"/>
                    <div>
                        <div className="page-contents">
                            {this.renderRadios()}
                        </div>
                        <div className="px-md-0 ml-md-19 button-container">
                            <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname}}
                                        disabled={this.state.link === ""}> Next </ButtonLink>
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>
                <FalconFooter/>

            </React.Fragment>
        );
    }

    private renderRadios = (): React.JSX.Element => {
        if (this.state.policies) {
            const monthlyMotorPolicyPresent = (productHelper.includesMotorProduct(this.state.policies)) ||
                productHelper.includesNonExpiredMotorPolicies(this.state.policies);
            const rentersPolicyPresent = (productHelper.includesRentersProduct(this.state.policies)) ||
                productHelper.includesNonExpiredRentersPolicies(this.state.policies);
            const annualMotorPolicyPresent = (productHelper.includesWolfMotorProduct(this.state.policies)) ||
                productHelper.includesNonExpiredWolfMotorPolicies(this.state.policies);

            return (
                <div className="panel">
                    <p className="font-weight-semi-bold ml-1 mt-3 pr-4">Please choose what type of claim you want to make?</p>
                    {monthlyMotorPolicyPresent && <div className="custom-control mt-2 ml-2 mb-3">
                        <input
                            className={"custom-radiobutton cursor-pointer"}
                            type="radio"
                            name="product-motor"
                            id="product-motor"
                            value="motor"
                            checked={this.state.motorChecked}
                            onChange={this.handleOnChangeEvent}
                        />
                        <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                               htmlFor="product-motor">
                            Car (monthly subscription)
                        </label>
                    </div>}
                    {rentersPolicyPresent && <div className="custom-control mt-2 ml-2 mb-3">
                        <input
                            className={"custom-radiobutton cursor-pointer"}
                            type="radio"
                            name="product-renters"
                            id="product-renters"
                            value="renters"
                            checked={this.state.rentersChecked}
                            onChange={this.handleOnChangeEvent}
                        />
                        <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                               htmlFor="product-renters">
                            Renters (monthly subscription)
                        </label>
                    </div>}
                    {annualMotorPolicyPresent && <div className="custom-control mt-2 ml-2 mb-3">
                        <input
                            className={"custom-radiobutton cursor-pointer"}
                            type="radio"
                            name="product-annual-motor"
                            id="product-annual-motor"
                            value="annual"
                            checked={this.state.annualMotorChecked}
                            onChange={this.handleOnChangeEvent}
                        />
                        <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                               htmlFor="product-annual-motor">
                            Car (annual cover)
                        </label>
                    </div>}
                </div>
            );
        } else {
            return (<></>);
        }

    };

    private handleOnChangeEvent = (event: any): void => {
        if (event.target.value === "motor") {
            this.setState({
                link: "/dashboard/windscreen",
                motorChecked: true,
                rentersChecked: false,
                annualMotorChecked: false
                });
        } else if (event.target.value === "renters") {
            this.setState({
                link: "/dashboard/rentersClaims/new",
                motorChecked: false,
                rentersChecked: true,
                annualMotorChecked: false
                });
        } else if (event.target.value === "annual") {
            const policyNumber = this.state.policies ? this.state.policies[0].policyNumber : "";
            this.setState({
                link: `/dashboard/pickAnnualMotorClaimKind/${policyNumber}`,
                motorChecked: false,
                rentersChecked: false,
                annualMotorChecked: true
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/PickClaimKindPage.tsx